import React, { useEffect } from 'react';
import { useAnalytics } from '../context/AnalyticsContext';
import { setAnalyticsDispatch } from '../store/analyticsMiddleware';

/**
 * Connector component that links the Analytics Context with Redux
 * This component should be mounted early in the component tree
 * after both Redux Provider and Analytics Provider are available
 */
const AnalyticsConnector = () => {
  const { dispatchAnalyticsEvent } = useAnalytics();
  
  useEffect(() => {
    // Set the dispatch function so Redux middleware can send events to PostHog
    setAnalyticsDispatch(dispatchAnalyticsEvent);
    
    // Clean up on unmount
    return () => setAnalyticsDispatch(null);
  }, [dispatchAnalyticsEvent]);
  
  // This is a non-visual component that just connects systems
  return null;
};

export default AnalyticsConnector; 